import { Navigate } from 'react-router-dom';

/**
 * Clash Royale account linking is unified into the verified flow at
 * `/duels/link` (player tag + in-game API token). That single verify proves
 * ownership AND registers the account on the Laravel monolith (so tournament
 * join works) AND primes the QBot stats/deck section — so there's no longer a
 * separate tag-only link here.
 *
 * This route is kept as a redirect so existing links + the CR section's
 * "not linked" redirects (CRHome / CRBattles / CRDeckCheck / CRCoach still
 * navigate to `/cr/link`) funnel to the canonical verify. `replace` keeps the
 * back button landing on the originating screen instead of looping here.
 */
export function CRLink() {
  return <Navigate to="/duels/link" replace />;
}
